import { Container, Typography, Box } from "@mui/material";
import Footer from "../components/Footer";
import { ReactComponent as Logo } from "../assets/Icons/onboarding-logo.svg";
import DeviceMetadataTracker from "../components/DeviceMetadataTracker";


const PublicLayout = ({ children }) => {
  return (
    <Container maxWidth="md">
      <DeviceMetadataTracker />
      <Container
        className={"shadowLayout"}
        sx={{
          top: "0",
          zIndex: "5",
          background: "white",
          paddingBottom: "15px",
        }}
        maxWidth="md"
      >
        <div className="layoutForm">
          {<Box width={32} height={32} />}
          <Logo />
          <Box width={32} height={32} />
        </div>
      </Container>
      <Box sx={{ py: 5, textAlign: "center" }}>{children}</Box>
      <Footer />
    </Container>
  );
};

export default PublicLayout;
